import React, { useMemo } from "react";
import { HiOutlineArrowRight } from "react-icons/hi";
import { classNames } from "Utils/utils";
import { VERTEX360_COPILOT_FOLLOW_UP_CHIPS } from "../constants/vertex360CopilotConstants";

const FollowUpChips = ({ onSelect, disabled = false, suggestions }) => {
  // Backend supplies contextual chips per reply (complete.data.suggestions).
  // An explicit empty array (e.g. clarify replies) means "no chips". Fall back
  // to the static list only for older messages that predate dynamic chips.
  const chips = useMemo(
    () =>
      Array.isArray(suggestions)
        ? suggestions
        : VERTEX360_COPILOT_FOLLOW_UP_CHIPS,
    [suggestions]
  );

  const chipsKey = useMemo(() => chips.join("|"), [chips]);

  if (!chips.length) return null;

  return (
    <div
      key={chipsKey}
      className="copilot-follow-up-chips-mount mt-3 flex flex-wrap gap-2"
      aria-label="Suggested follow-up questions"
    >
      {chips.map((chip) => (
        <button
          key={chip}
          type="button"
          disabled={disabled}
          onClick={() => onSelect?.(chip)}
          className={classNames(
            "copilot-prompt-action inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-slate-600",
            "hover:text-[#4B6CB7]",
            "disabled:cursor-not-allowed disabled:opacity-50"
          )}
        >
          {chip}
          <HiOutlineArrowRight className="h-3 w-3 text-[#4B6CB7]/70" />
        </button>
      ))}
    </div>
  );
};

export default FollowUpChips;
